import React from 'react'

const Error404 = ({hideBackground = false}) => {
    console.log(hideBackground)
        if (hideBackground) {
            document.body.style.backgroundColor = "transparent";
            document.getElementById('root').style.backgroundColor = "transparent";
        }
        return (
            <div className="error-404">
                <div>
                    <div>404</div>
                    <div>Страница не найдена</div>
                </div>
            </div>
        );
    }
;

export default Error404
